import { Button, Table, TableBody, TableCell, TableHead, TableRow, Theme, WithStyles, createStyles, withStyles } from "@material-ui/core";
import { ContactList, deleteOobSms, getEnrolledOobSms, updateOobSms } from "../../../modules/authmethods";
import { IStoreState, ThunkDispatch } from "../../../modules";
import PhoneNumberInput, { PhoneNumberEnrolment, newEnrolment } from "../../../components/PhoneNumberInput";
import React, { Fragment } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import GenericEnroll from "./GenericEnroll";
import PropTypes from 'prop-types';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { enrolmentToContactList } from "../../../helpers/credentials/OobSms";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

const styles = (theme: Theme) => createStyles({
  phoneEnrolments: {
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  phoneEnrolment: {
    alignSelf: 'stretch',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2)
  },
  phoneInput: {
    flex: 1,
  },
  buttonToolbar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: theme.spacing(2)
  },
  addIcon: {
    marginRight: theme.spacing(1)
  },
})

type OobSmsEnrollState = {
  enrolments: PhoneNumberEnrolment[]
  loading: { [key: number]: boolean }
  error: string
}

class OobSmsEnroll extends React.Component<Props, OobSmsEnrollState> {
  static propTypes = {
    expanded: PropTypes.bool.isRequired,
    setExpanded: PropTypes.func.isRequired
  }

  state = {
    enrolments: [] as PhoneNumberEnrolment[],
    loading: {},
    error: "",
  }

  componentDidMount = () => {
    this.reloadEnrolment()
  }

  reloadEnrolment = () => {
    return this.props.getEnrolledOobSms().then((_: any) => {
      let enrolments = this.props.authmethods.oobSms.enrolments as PhoneNumberEnrolment[]

      this.setState({
        enrolments,
        loading: {},
        error: "",
      })
    })
  }

  handleAdd = () => {
    this.setState({
      enrolments: this.state.enrolments.concat(newEnrolment())
    })
  }

  handleDelete = (pne: PhoneNumberEnrolment) => (fromDatabase: boolean) => {
    if (fromDatabase) {
      return this.props.deleteOobSms(enrolmentToContactList(pne)).then(() => {
        this.reloadEnrolment()
      })
    }
    else {
      this.setState(prevState => ({
        enrolments: prevState.enrolments.filter(e => pne !== e)
      }))
      return (Promise.resolve()) as Promise<any>
    }
  }

  handlePhoneNumberInputChange = (i: number) => (pne: PhoneNumberEnrolment): Promise<boolean> => {
    return new Promise<boolean>((resolve: (result: boolean) => void, reject: (a: any) => void) => this.setState(prevState => {
      const enrolments = prevState.enrolments.map((item, j) => {
        if (i === j) {
          return pne
        } else {
          return {
            ...item,
            default: pne.default ? false : item.default
          }
        }
      })
      return { enrolments }
    }, () => resolve(true)))

  }

  // should not have a then clause to this return, only catch

  handleSave = (pne: PhoneNumberEnrolment): Promise<boolean> => {
    let contactList: ContactList

    let validNums = this.state.enrolments.filter(pne => pne.phoneNumber.isValid())
    contactList = enrolmentToContactList(validNums)

    return this.props.updateOobSms(contactList, contactList.length > 1 ? 'UPDATE' : 'ADD')
      .then((_: any) => {
        return this.reloadEnrolment().then((_: any) => { return true })
      })
      .catch((error: Error) => {
        console.error(error)
        throw error
      })
  }

  renderForm = () => {
    const { classes } = this.props
    const { enrolments: phoneNumbers } = this.state

    return <Fragment>
      <div className={classes.phoneEnrolments}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Default</TableCell>
              <TableCell>Phone Number</TableCell>
              <TableCell>{/* delete */}</TableCell>
              <TableCell>{/* status */}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {phoneNumbers.length > 0 ?
              phoneNumbers.sort((a, b) => (a.key > b.key) ? 1 : ((b.key > a.key) ? -1 : 0)).map((pne, i) =>
                <PhoneNumberInput
                  key={pne.key}
                  onDelete={this.handleDelete(pne)}
                  className={classes.phoneEnrolment}
                  enrolment={pne}
                  onChange={this.handlePhoneNumberInputChange(i)}
                  onSave={this.handleSave} />
              )
              : <TableRow>
                <TableCell colSpan={4} align="center">No phone numbers enrolled</TableCell>
              </TableRow>
            }
          </TableBody>
        </Table>
      </div>
      <div className={classes.buttonToolbar}>
        <Button onClick={this.handleAdd} color="primary"><FontAwesomeIcon icon={faPlus} className={classes.addIcon} /> Add a phone</Button>
      </div>
    </Fragment>
  }

  render = () => {
    return <GenericEnroll
      authMethodName="Out-of-Band SMS"
      enrolled={this.props.authmethods.oobSms.enrolled}
      renderForm={this.renderForm}
      expanded={this.props.expanded}
      setExpanded={this.props.setExpanded}
      error=""
      dirty={false} />
  }
}

const mapStateToProps = ({ accounts, authmethods, intl }: IStoreState) => ({
  accounts,
  authmethods,
  intl
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
      getEnrolledOobSms,
      updateOobSms,
      deleteOobSms,
    }, dispatch
  )

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {
  expanded: boolean
  setExpanded: (expanded: boolean) => void
  expandNext: () => void
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(OobSmsEnroll))